var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.29,
    height: 29.309,
    viewBox: "0 0 29.29 29.309",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "box",
    d: "M12.156,4.989a.685.685,0,0,0-.472.21L6.244,10.64l-.044.041a.685.685,0,0,0-.085.1l-.005.008q-.015.025-.029.051l-.005.008q-.013.026-.025.053l-.005.011q-.01.027-.018.055l-.005.022q-.007.027-.011.055T6,11.106s0,.007,0,.011,0,.032,0,.048V33.1q0,.034,0,.067a.685.685,0,0,0,.787.618H28.621l.022,0,.048,0,.018,0,.049-.008q.032-.006.063-.015h0l.019-.005.045-.019.019-.008.042-.021.016-.011a.686.686,0,0,0,.059-.038l.037-.029.016-.014.027-.023.007-.008L34.59,28.1a.685.685,0,0,0,.2-.485V5.681a.685.685,0,0,0-.5-.661q-.032-.01-.064-.016h0Q34.187,5,34.153,5H12.3a.685.685,0,0,0-.14-.008Zm.3,1.379h20l-4.113,4.113h-20l4.113-4.113Zm20.966.969v20l-4.113,4.113v-20ZM7.371,11.852H27.936V32.416H7.371V11.852ZM8.742,24.19v1.371h8.226V24.19Zm0,2.742V28.3h5.484V26.932Z",
    transform: "translate(-5.75 -4.737)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/Products.e24e875d612dd6ee7303f337940a26f6.svg";
export { ForwardRef as ReactComponent };